module.exports = __webpack_public_path__ + "media/images/news/news1-269b3081d6cc892a8cda94594e688ba9.png";